import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { OWF_GRANT_CREDITS_BY_COUNTRY } from "@faire/web-api--source/indigofair/settings/OWF_GRANT_CREDITS_BY_COUNTRY";
export var getSettingOwFGrantMoney = function() {
    return getSettingValueWithoutAssignment(OWF_GRANT_CREDITS_BY_COUNTRY, IFaireMoney.build({
        amount_cents: 500000,
        currency: "USD"
    }));
};
